export default {
    namespaced: true,
    state: {
        arukereso: {
            active: false,
            checked: false,
            text: '',
        }
    },
    mutations: {
        INIT (state, config) {
            state.arukereso.active = config.arukereso.active;
            state.arukereso.text = config.arukereso.text;
        },
        SET_ARUKERESO (state, checked) {
            state.arukereso.checked = checked;
        },
    }
}